import { axiosCurrency } from '../http-common';

class CurrencyService {
  list(params){
    return axiosCurrency.post("v1/currency/currency/list",params);
  }
  get(code){
    return axiosCurrency.post("v1/currency/currency/filter",{"code":code});
  }
}

export default new CurrencyService();